<template>
  
  <i class="fa-sort ml-1 text-gray-400 fad" 
    :class="orderby === col ? 'text-teal-600 ' + (sortorder === 'asc' ? 'fa-sort-down' : 'fa-sort-up') : ''"
    ></i>

</template>

<script>

export default {
  props: {
    col: String,
    orderby: String,
    sortorder: String,
  },
}
</script>
